<div class="row mb-2 mt-2 ms-0 me-0">
  <div class="me-auto col-md-4 p-0 col">
    <app-rota-page-switch [weekId]="weekId()" [isActiveRotaPage]="true"></app-rota-page-switch>
  </div>
  <div class="m-auto text-center col">
    <a routerLink="/rota-day/{{previousDate()}}"
       [ngClass]="{'link-disabled': isSunday(previousDate())}"
       class="btn btn-primary btn-sm me-3"><</a>
    <div class="week-with-date">
      <span class="week-number">Week {{ date() | dateParse | dateFormat: 'WW' }}</span>
      {{ date() | dateParse | dateFormat: 'ddd, D MMM YYYY' }}
    </div>
    <a routerLink="/rota-day/{{nextDate()}}"
       [ngClass]="{'link-disabled': isMonday(nextDate())}"
       class="btn btn-primary btn-sm ms-3">></a>
  </div>
  <div class="ms-auto col-md-4 col">
    <div class="legend">
      <div>
        <div class="legend-item"><span class="legend-overcapacity"></span> Overcapacity</div>
        <div class="legend-item"><span class="legend-power-hours"></span> Power Hours</div>
      </div>
      <div>
        <div class="legend-item"><span class="legend-undercapacity"></span> Undercapacity</div>
        <div class="legend-item"><span class="legend-away"></span> Away</div>
      </div>
    </div>
  </div>
</div>